import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import DrawerHeader from "./DrawerHeader";
import DrawerBody from "./DrawerBody";
import DrawerFooter from "./DrawerFooter";
import useWindowSize from "../../hooks/useWindowSize";
import DrawerBodyEmpty from "./DrawerBodyEmpty";
import { useSelector } from "react-redux";

const DrawerCartSummary = ({
  openDrawer,
  hideDrawer,
  onCloseDrawer,
  backdropRef,
  countActual,
}) => {
  const sizeDefaultDrawer = 500;
  const currency = useSelector((state) => state.global.currency);
  const globalState = useSelector((state) => state.global);
  const ResumenData = useSelector((state) => state.global.ResumenData);
  const [itemsAddCart, setItemsAddCart] = useState([]);
  const [width, setWidth] = useState(sizeDefaultDrawer);
  const size = useWindowSize();

  useEffect(() => {
    const items = ResumenData.filter((item) => item.actual === false);
    setItemsAddCart(items);
  }, [ResumenData]);

  useEffect(() => {
    const width = size.width;
    if (width < sizeDefaultDrawer) {
      setWidth(width);
    } else if (width !== sizeDefaultDrawer) {
      setWidth(sizeDefaultDrawer);
    }
  }, [size]);

  const formatAmount = (amount) => {
    const amountFormat = parseFloat(amount).toLocaleString("en-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `$${amountFormat} ${currency}`;
  };

  return (
    <Drawer
      open={openDrawer}
      onClose={onCloseDrawer}
      anchor="right"
      disableEnforceFocus
      ModalProps={{
        // Asignar una referencia al backdrop
        BackdropProps: {
          ref: backdropRef,
        },
      }}
    >
      <Box
        role="presentation"
        sx={{
          width: width,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <DrawerHeader countActual={countActual} hideDrawer={hideDrawer} />

        {countActual === 0 && <DrawerBodyEmpty />}

        {countActual > 0 && (
          <>
            <DrawerBody
              itemsAddCart={itemsAddCart}
              formatAmount={formatAmount}
              globalState={globalState}
            />
            <DrawerFooter
              itemsAddCart={itemsAddCart}
              formatAmount={formatAmount}
            />
          </>
        )}
      </Box>
    </Drawer>
  );
};

export default DrawerCartSummary;
